export default {
  name: "ShiftSchedule",

  props: {
    shifts: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    has_shifts() {
      return this.shifts && this.shifts.length > 0;
    },
  },
};
